// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__38zos","title":"Images90_title__2zX1F","images":"Images90_images__2JbFb"};